import { Can } from '@casl/vue';
import { ButtonEdit } from '~/components/Buttons/ButtonEdit';
import defaultTo from 'ramda/src/defaultTo';
import always from 'ramda/src/always';

const call = defaultTo(always(undefined));

/**
 * @typedef PHPLogisticEntry
 * @property {string} ID
 * @property {string} NAME
 * @property {string} PROPERTY_CITY_FINISH_VALUE
 * @property {string} PROPERTY_CITY_START_VALUE
 * @property {string} PROPERTY_PRICE_VALUE​
 * @property {string} PROPERTY_TRACK_VALUE
 * @property {string} PROPERTY_TRANSPORT_VALUE
 * @property {string} PROPERTY_CARGO_TYPE_VALUE
 * @property {string} DATE_CREATE
 */

export class LogisticEntry {
	/**
	 *
	 * @param {PHPLogisticEntry} data
	 */
	constructor(data) {
		this.id = data.ID;
		this.name = data.NAME;
		this.startPoint = data.PROPERTY_CITY_START_VALUE;
		this.destination = data.PROPERTY_CITY_FINISH_VALUE;
		this.price = data.PROPERTY_PRICE_VALUE;
		this.trackingNumber = data.PROPERTY_TRACK_VALUE;
		this.service = data.PROPERTY_TRANSPORT_VALUE;
		this.type = data.PROPERTY_CARGO_TYPE_VALUE;
	}
}

const Item = {
	name: 'LogisticItem',
	functional: true,
	props: {
		item: LogisticEntry,
	},
	render(h, { props, listeners }) {
		return (
			<span>
				{ props.item.name }
				<Can I="update" a="Logistic">
					<ButtonEdit
						class="ml-2"
						style={{ color: '#009996' }}
						onClick={ () => call(listeners.edit)(props.item) }
					/>
				</Can>
			</span>
		)
	},
}

export const LogisticList = {
	name: 'LogisticList',
	functional: true,
	props: {
		list: {
			type: Array,
			default: () => [],
		},
	},
	render(h, { props, listeners }) {
		return props.list.length > 0 ? (
			<ol>
				{ props.list.map((item) => (
					<li>
						<Item
							item={ item }
							onEdit={ () => call(listeners.edit)(item) }
						/>
					</li>
				))}
			</ol>
		) : null;
	},
}
